
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();

import { WykrojnikiCostSvc } from "./WykrojnikiCostSvc";
import { Next, Route } from 'vue-router';
import { IOferta } from "./IOferta";
import ButtonVue from "@/lib/Button.vue";

import { FinSvc } from "@/fin/FinSvc";
import {OfertaCell} from "./OfertaCell"
import {OfertaPricer} from "./OfertaPricer"

import Store from "@/store/Store"; 
import { IMasterData, MasterData } from "@/store/MasterData"; 
import { INarzut } from "@/fin/INarzut";
import { Transport } from "@/transport/ITransport";
import { IUser } from "@/../../server/src/user/IUser";
import { IPrj } from "@/prj/IPrj";
import { TreeSvc } from "@/tree/TreeSvc";
import { ITree } from "@/tree/ITree";
import { Translator } from "./Translator"
import { ILicz } from "./Log";
import  CostVue from "./CostVue.vue"

@Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<OfertaVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: OfertaVue) => { vm.tree_id = to.params.id });
        },
      components: { ButtonVue, CostVue }
})

export default class OfertaVue extends Vue {
  key:number=0;
  key_ceny:number=0;
  tree_id:any;
  oferta: IOferta|undefined = undefined;
  data:any;
  wazna_do:string=""
  narzut:INarzut|undefined=undefined;
  masterData:IMasterData|undefined
  user:IUser=bus.get_user();
  klient:string=""
  klient_kontakt:string=""
  projekt:string=""
  //languages:string[] = ["pl","de", "gb","ua"]
  languages:string[] = ["pl","de", "gb"]
  language:string="pl"
  translator:Translator|undefined
  show=true;
  bodykey=0;
  translations:any[]=[]
  koszt_wykrojnika = 0
  koszt_polimeru = 0
  expl_price_manual:ILicz|undefined=undefined;
  expl_price_auto:ILicz|undefined=undefined;
  expl_narzut_manual:ILicz|undefined=undefined;
  expl_narzut_auto:ILicz|undefined=undefined;
  expl_key=0;
  expl_naklad=-1;
  expl_zmian=-1;
  rodzaje_kalkulacji:string[] = ["STARA KALKULACJA", "NOWA KALKULACJA"] 
  rodzaj_kalkulacji = "NOWA KALKULACJA"
  predkosc_druku:number | undefined =0;
  show_narzut=false;
  komentarz_dla_klienta=""

  show_oferta_saved=0;

  oferta_pricer: OfertaPricer | undefined;
  key_cell:any={}
  excel:String=""
  oferty_archiwalne:any[]=[]
  oferty_archiwalne_selected_id=undefined
  oferty_archiwalne_key=0;

  waluta_wykrojnik="EUR"
  waluta_polimer="PLN"

  t(key:any, values:any) {
    if (!this.translator) return "{0} {1} {2}"
    return this.translator.t(key, values)
  }

  async mounted() {
    this.masterData = await (await new Store().getStore()).masterData;


    if (this.masterData && this.masterData!=undefined) {
      this.translations=this.masterData.lang;
      if (this.masterData.narzut) {
        this.narzut = this.masterData.narzut;
        this.user=bus.get_user();
        await this.get_oferta();
        await this.get_oferty_arch_ids();
          
      }
    }
  }

  switch_show_narzut() {
    if (this.show_narzut) this.show_narzut=false;
    else this.show_narzut=true;
    this.key++;
    this.key_ceny++;
  }

  async set_lang(l:string) {
    if (!this.oferta) return;
    if (!this.oferta.fin) return;
    if (!this.masterData) { 
      console.log("no masterdata")
      return 
    }

    this.show=false;
    this.bodykey++
    this.oferta.fin.language=l
    this.translator=new Translator(l, this.translations);
    await new FinSvc().save(this.oferta.fin);
    this.show=true;
    this.bodykey++
 
  }

  async get_oferta() {
    
    console.log("tree_id", this.tree_id)
    console.log("get_oferta")
    const oferta = <IOferta> await new WykrojnikiCostSvc().get_oferta(this.tree_id)
    //this.predkosc_druku = oferta.wykrojnik_sel_old.koszt_1K.predkosc_druku
    const czas = oferta.wykrojnik_sel.koszt_1K.czas ? oferta.wykrojnik_sel.koszt_1K.czas : 0
    const mb   = oferta.wykrojnik_sel.koszt_1K.mb   ? oferta.wykrojnik_sel.koszt_1K.mb : 0
    this.predkosc_druku = czas ? Math.round((mb/czas)*10)/10 : 0

    console.log("get_oferta end", oferta)

    if (oferta)  { 
          
          const tree:ITree|undefined = await new TreeSvc().find_by_id(this.tree_id);
          if (tree) {
            this.projekt=tree.idn
            const prj:IPrj = await bus.call("/api/projekt/find_by_id", {type:"prj",_id:tree.parent_id} );
            if (prj && prj.klient && prj.klient.text) this.klient=prj.klient.text
            if (prj && prj.klient_kontakt && prj.klient_kontakt.text) this.klient_kontakt=prj.klient_kontakt.text
          }

          if (oferta.fin && !oferta.fin.language) {
            oferta.fin.language="pl"
          }

          this.koszt_wykrojnika =oferta.fin.kosztWykrojnikaEUR
          this.komentarz_dla_klienta= oferta.fin.komentarz_dla_klienta

          if (oferta.fin.koszt_polimeru_w_PLN==undefined) {
            if (oferta.fin.waluta_kalkulacji=="EUR") { this.koszt_polimeru = oferta.fin.kosztPolimeruEUR; this.waluta_polimer="EUR" }
            else {this.koszt_polimeru = oferta.fin.kosztPolimeruPLN; this.waluta_polimer="PLN" }    
          }
          else if (oferta.fin.koszt_polimeru_w_PLN==0) { this.koszt_polimeru = oferta.fin.kosztPolimeruEUR;  this.waluta_polimer="EUR" }
          else if (oferta.fin.koszt_polimeru_w_PLN==1) { this.koszt_polimeru = oferta.fin.kosztPolimeruPLN; this.waluta_polimer="PLN"}

          if (oferta.fin.koszt_wykrojnika_w_PLN==undefined) {
            if (oferta.fin.waluta_kalkulacji=="EUR") { this.koszt_wykrojnika = oferta.fin.kosztWykrojnikaEUR;  this.waluta_wykrojnik="EUR" }
            else {this.koszt_wykrojnika = oferta.fin.kosztWykrojnikaPLN;  this.waluta_wykrojnik="PLN" }    
          }
          if (oferta.fin.koszt_wykrojnika_w_PLN==0)      { this.koszt_wykrojnika = oferta.fin.kosztWykrojnikaEUR; this.waluta_wykrojnik="EUR" }
          else if (oferta.fin.koszt_wykrojnika_w_PLN==1) { this.koszt_wykrojnika = oferta.fin.kosztWykrojnikaPLN; this.waluta_wykrojnik="PLN" }


          if (oferta.fin.language) {
            this.translator=new Translator(oferta.fin.language, this.translations);
          }

          this.data = oferta.data
          if (this.data) {
            this.data = this.data.replace('T',' ').replace('Z','').substring(0,19)
          }
          if (oferta.wazna_do) {
            this.wazna_do = oferta.wazna_do.toString().replace('T',' ').replace('Z','').substring(0,10)
          }

          if (oferta.surowiec && oferta.grupa_maszyn) {
            this.oferta=oferta; 
            this.calc_prices();
          }        

        oferta._id=undefined; 
        this.oferty_archiwalne_selected_id=undefined;
        this.key++; 
    }
    else this.key=0;
  }



  explain(naklad:number,zmian:number) {
      this.expl_key=0;
      if (this.oferta_pricer) {
         this.expl_price_auto     = this.oferta_pricer?.explain_price(naklad,zmian,this.oferta_pricer.get_narzut_auto(naklad,zmian));
         this.expl_price_manual   = this.oferta_pricer?.explain_price(naklad,zmian,this.oferta_pricer.get_narzut_manual(naklad,zmian));
  
         this.expl_narzut_auto    = this.oferta_pricer?.explain_narzut(naklad,zmian,this.oferta_pricer.get_price_auto(naklad,zmian));
         this.expl_narzut_manual  = this.oferta_pricer?.explain_narzut(naklad,zmian,this.oferta_pricer.get_price_manual(naklad,zmian));
         this.expl_key++
      }
}

  change_rodzaj_kalkulacji() {
    if (this.rodzaj_kalkulacji=="STARA KALKULACJA") {
      this.show_narzut = false;
      this.key_ceny++
      this.key++
    }
    this.calc_prices();  
  }


  
  calc_prices() {

        this.key_ceny = 0;
        if (!this.oferta) return;

        if (!this.narzut) return;
        /*
        this.oferta.fin.prices_auto = {}
        this.oferta.fin.narzuty_auto = {}
        this.oferta.fin.prices_manual = {}
        this.oferta.fin.narzuty_manual = {}
        */
        const colors = 0
        this.oferta_pricer = new OfertaPricer(this.oferta, this.rodzaj_kalkulacji, this.narzut.narzut_procent_min, this.narzut.narzut_procent_cel, this.narzut.narzut_procent_max, colors, this.user);


        console.log('@@@@@@@@@@@@@@@@@@ prices_auto',this.oferta.fin.prices_auto)
        console.log('@@@@@@@@@@@@@@@@@@ narzuty_auto',this.oferta.fin.narzuty_auto)
        console.log('@@@@@@@@@@@@@@@@@@ prices_manual',this.oferta.fin.prices_manual)
        console.log('@@@@@@@@@@@@@@@@@@ narzuty_manual',this.oferta.fin.narzuty_manual)

        this.key_cell={}
        for (let i=0;i<this.oferta_pricer.naklady.length;i++) {
            const naklad = this.oferta_pricer.naklady[i]
            if (!this.key_cell[naklad]) this.key_cell[naklad]={}
            for (let j=0;j<this.oferta_pricer.zmiany.length;j++) {
                const zmian = this.oferta_pricer.zmiany[j]
                this.key_cell[naklad][zmian]={ price_manual:1, naklad_manual:1}
            }
        }
        if (this.oferta_pricer?.prices_auto_valid) this.key_ceny++;
        this.show_oferta_saved=0     

  }

  async get_oferta_saved(tree_id:any) {
    const oferta = <IOferta> await new WykrojnikiCostSvc().get_oferta_saved(tree_id)
    console.log("get_oferta_saved end", oferta)
    if (oferta._id)  { 
      this.oferta=oferta; 
      if (!this.narzut) return;

      this.oferta_pricer = new OfertaPricer(this.oferta, this.rodzaj_kalkulacji, this.narzut.narzut_procent_min, this.narzut.narzut_procent_cel, this.narzut.narzut_procent_max, 0, this.user);

      this.show_oferta_saved=1     
      this.oferty_archiwalne_selected_id=oferta._id
      this.key++; 
      this.key_ceny++ 
      }
    else { 
      alert("Brak jeszcze zapisanej oferty. Pokazuję wyliczoną.")
      await this.get_oferta()
    }
  }


  async get_oferta_by_id(oferta_id:any) {
    const oferta = <IOferta> await new WykrojnikiCostSvc().get_oferta_by_id(oferta_id)
    console.log("get_oferta_by_id end", oferta)
    if (oferta._id)  { 
      this.oferta=oferta; 
      if (!this.narzut) return;
      this.data = oferta.data
      if (this.data) {
        this.data = this.data.replace('T',' ').replace('Z','').substring(0,19)
      }
      console.log(this.oferta.fin)
      this.oferta_pricer = new OfertaPricer(this.oferta, this.rodzaj_kalkulacji, this.narzut.narzut_procent_min, this.narzut.narzut_procent_cel, this.narzut.narzut_procent_max, 0, this.user);

      this.show_oferta_saved=1     
      this.oferty_archiwalne_selected_id=oferta_id
      this.key++; 
      this.key_ceny++ 
      console.log(this.oferta.data)
      }
    else { 
      alert("Brak jeszcze zapisanej oferty. Pokazuję wyliczoną.")
      await this.get_oferta()
    }
  }

  async save_oferta() {
    if (!this.oferta) return;
    const o = <IOferta> await new WykrojnikiCostSvc().save_oferta(this.oferta)
    console.log("oferta_saved",o)

   
    if (o)  {
      await this.get_oferta_saved(this.tree_id)
      alert("Zapisano ofertę")
      await this.get_oferty_arch_ids();
    }
  }


  async get_oferty_arch_ids() {
    if (!this.tree_id) return;
    this.oferty_archiwalne =  await new WykrojnikiCostSvc().get_oferty_arch_ids(this.tree_id)
    this.oferty_archiwalne_key++
  }

  comma(price:Number):string {
    let s=price.toString()
    s=s.replace('.',',')
    return s;
  }

  get_excel() {
    let str=""
    const sep="\t"
    if (!this.oferta_pricer) return "";
    if (!this.oferta) return;

    str+='  '+sep;
    for (let j=0;j<this.oferta_pricer.zmiany.length;j++) {
      str+=(this.oferta_pricer.zmiany[j]+1)+sep
    }

    for (let i=0;i<this.oferta_pricer.naklady.length;i++) {
      const naklad = this.oferta_pricer.naklady[i]
      str+='\n'+naklad
      for (let j=0;j<this.oferta_pricer.zmiany.length;j++) {
        str+=sep
        const zmian = this.oferta_pricer.zmiany[j]
        let price=0;
        if (this.show_oferta_saved) {
          price = this.oferta.fin.prices_auto[naklad][zmian].toFixed(2)
        } else {
          price = this.oferta_pricer.money2(this.oferta_pricer.get_price_manual(naklad,zmian))
        }
        str+=this.comma(price)
      }
     
    }
    navigator.clipboard.writeText(str)
    alert("Skopiowano ceny do notatnika. Wejdź do excela i naciśnij Ctrl+V")
    return str;
  }


  print() {
    const divId:string="OfertaDiv"
    const title:string="Oferta"

    let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');
    if (!mywindow) return;
    mywindow.document.write(`<html><head><title>${title}</title>`);
    mywindow.document.write('</head><body >');
    const el = document.getElementById(divId)
    if (!el) return;

    mywindow.document.write(el.innerHTML);
    mywindow.document.write('</body></html>');


    mywindow.document.write(`<style>`);
    mywindow.document.write(`

.numinp {
   width: 74px;
}

.blk {
    margin: 0px auto;
    font-size: 13px;
    display:inline-block;
    text-align: left;
    margin-bottom: 5px;;
}

.header {
    width:735px;
    text-align: center;
    vertical-align:middle;
    margin:auto;
}
.body {
    width:900px;
    text-align: center;
    vertical-align:middle;
    margin:auto;
}
.warunki {
    font-size: 10px;
    width:735px;
    text-align: center;
    vertical-align:middle;
    margin:auto;
}
.adres {
  padding: 5px;
  height:150px;
  width: 350px;
  font-size: 12px;
  border: 1px  solid steelblue;
  border-radius: 3px;
  text-align: left;
  background-color:white !important;
  display: inline-block;
}
.klient {
  padding: 5px;
  height:150px;
  width: 350px;
  font-size: 12px;
  border: 1px  solid steelblue;
  border-radius: 3px;
  text-align: right;
  background-color:white !important;
  display: inline-block;
}
.num {
  width: 70px;
  padding: 1px;
  font-size: 12px;
  border: 1px  solid steelblue;
  border-radius: 3px;
  text-align: right;
  margin:1px;
  display: inline-block;
}
.wariant {
  width: 70px;
  padding: 1px;
  font-size: 12px;
  border: 1px  solid steelblue;
  border-radius: 3px;
  text-align: right;
  margin:1px;
  background-color: rgb(210, 219, 235) !important;
  display: inline-block;
}
.zespt {
  width: 200px;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-right: 3px;
  font-size: 12px;
  border: 1px  solid steelblue;
  border-radius: 3px;
  text-align: right;
  margin:1px;
  background-color: white !important;
  display: inline-block;
}
.zespv {
  width: 400px;
  padding-left: 3px;
  font-size: 12px;
  border: 1px  solid steelblue;
  border-radius: 3px;
  text-align: left;
  margin:1px;
  display: inline-block;
}
.numn {
  width: 70px;
  padding: 1px;
  font-size: 12px;
  border: 1px  solid steelblue;
  border-radius: 3px;
  text-align: right;
  margin:1px;
  background-color: rgb(146, 177, 235) !important;
  display: inline-block;
}

.cenytbl {
 
  text-align: center;
  margin: auto;
}

.cenydiv {
 
  text-align: center;
   display: block;
}
@media print {
  .nobreak { page-break-inside: avoid; }
}

`);

    mywindow.document.write(`</style>`);

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

  return true;
  }
}
